import { Component, OnInit, Output, AfterViewInit, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { DateFormatPipe } from 'src/app/pipes/dateformat.pipe';

@Component({
	selector: 'app-view-rozgar-melas-filter',
	templateUrl: './view-rozgar-melas-filter.component.html',
	styleUrls: ['./view-rozgar-melas-filter.component.css'],
	providers: [DateFormatPipe]
})
export class ViewRozgarMelasFilterComponent implements OnInit, AfterViewInit {
	constructor(
		private geographiesService: GeographiesService,
		private _script: ScriptLoaderService,
		private dateformat: DateFormatPipe
	) { }
	states: any;
	districts: any;
	@Input() status: any;
	@Input() customFilter: any;
	@Output() searchFilters: EventEmitter<any> = new EventEmitter<any>();
	@Output() resetFilters: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('startDate') startDate: ElementRef;
	@ViewChild('endDate') endDate: ElementRef;

	modelObj: any = {
		state: '',
		district: '',
		status: '',
		startDate: '',
		endDate: '',
		keyword: ''
	};
	startDt = '';
	endDt = '';
	ngOnInit() {
		this.getStates();
	}
	ngAfterViewInit() {
		this._script.loadScripts('app-view-rozgar-melas-filter',
			['./assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js',
				'assets/demo/default/custom/components/forms/widgets/bootstrap-select.js']);
	}
	showSelected(ngmodel, userobj) {
		if (ngmodel && userobj) {
			return ngmodel.userName === userobj.userName;
		}
	}
	reset() {
		this.districts = [];
		this.modelObj.state = '';
		this.modelObj.district = '';
		this.modelObj.startDate = '';
		this.modelObj.status = '';
		this.modelObj.endDate = '';
		this.modelObj.keyword = '';
		if (this.startDate && this.startDate.nativeElement && this.startDate.nativeElement.value) {
			this.startDate.nativeElement.value = '';
		}
		if (this.startDate && this.endDate.nativeElement && this.endDate.nativeElement.value) {
			this.endDate.nativeElement.value = '';
		}
		this.resetFilters.emit();
	}
	getStates() {
		this.states = [];
		this.geographiesService.getStates().subscribe(
			({ states }) => {
				this.states = states;
			},
			err => {
				// const fake = [{ name: 'A', value: 'a' }, { name: 'B', value: 'b' }];
				// this.copyArray(this.addressData.states, fake);
			}
		);
	}
	getDistricts() {
		this.districts = [];
		this.geographiesService.getDistricts(this.modelObj.state.code)
			.subscribe(districts => {
				this.districts = districts.districts;
			}, error => {
				console.log(`Error while fetching districts : ${error}`);
			});
	}
	applyFilters() {
		const emitData = {};
		if (this.modelObj.district && this.modelObj.district !== '') {
			emitData['district'] = this.modelObj.district.name;
		}
		if (this.modelObj.state && this.modelObj.state !== '') {
			emitData['state'] = this.modelObj.state.name;
		}
		if (this.modelObj.status && this.modelObj.status !== '') {
			emitData['status'] = this.modelObj.status;
		}
		if (this.modelObj.keyword && this.modelObj.keyword !== '') {
			emitData['keyword'] = this.modelObj.keyword;
		}
		if (this.startDate.nativeElement.value && this.startDate.nativeElement.value !== 'Invalid date') {
			emitData['startDate'] = this.dateformat.transform(this.startDate.nativeElement.value);
		}
		if (this.endDate.nativeElement.value && this.endDate.nativeElement.value !== 'Invalid date') {
			emitData['endDate'] = this.dateformat.transform(this.endDate.nativeElement.value);
		}
		this.searchFilters.emit(emitData);
	}
}
